import { JsonapiEntity, entity } from 'jsonapi-transformers';

@entity({ type: 'roles' })
export class RoleRecord extends JsonapiEntity<RoleRecord> {}
